import { Post, Delete, Get } from "./common";

export default class WatchlistService {
  static addToFavorites = async (token: string, data: any) =>
    await Post({ path: "watchlist/", token, body: data });

  static removeFromFavorites = async (token: string, id: string) =>
    await Delete({ path: `watchlist/${id}`, token });

  static getMine = async (token: string) =>
    await Get({ path: `watchlist/`, token });

  static getMineWithData = async (token: string, data: any) =>
    await Post({ path: "watchlist/data", token, body: data });
}
